import * as React from 'react';

import SignUpButtonGroup from './SignUpButtonGroupPage';
import StaticPageLayout from '#/layouts/StaticPageLayout';

const PrivacyPage = () => {
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <StaticPageLayout>
      <div>
        <div className="px-32 py-20 bg-blue-50">
          <div className="px-20 py-16 bg-white">
            <div className="flex flex-col text-gray-600 gap-y-10">
              <h2 className="text-black">Introduction</h2>
              <div className="space-y-5 text-justify">
                <p>
                  This is the Personal Data Protection Policy of Daily Move Sdn Bhd (“MOVE”)
                  (“Policy”). In accordance with the Personal Data Protection Act 2010 of the Laws
                  of Malaysia (the “PDPA”), this Policy sets out how MOVE manages, collects, uses
                  and discloses Personal Data (as defined below) belonging to you.
                </p>
                <p>
                  This Privacy Policy concerns the following personal data that we collect about you
                  when you use or access our web applications, mobile applications (jointly referred
                  to as “Applications”) and our website at move.com.my. You must only submit to us,
                  the MOVE’s platform, information which is accurate and not misleading and you must
                  keep it up to date and inform us of changes (more information below). We reserve
                  the right to request for documentation to verify the information provided by you.
                </p>
                <p>
                  We operate Applications and websites to act as a platform to connect users of our
                  platform to drivers, including individuals using other modes of transportation,
                  and to help facilitate such drivers to provide on-demand delivery services and
                  purchasing services (“Services”). Our Applications and Services are primarily
                  designed for adults.
                </p>
                <p>
                  We will not knowingly collect any personal data from minors (i.e. persons who have
                  not attained the age of 18 years, or the equivalent minimum age for full legal
                  capacity in relevant jurisdiction) unless such data has been provided with prior
                  consent from a relevant person (i.e. a person who has parental responsibility for
                  the minor).
                </p>
                <p>
                  In the event that you as the relevant person disclose such personal data of a
                  minor under your parental responsibility to us, you hereby consent to the
                  collection and processing of such minor’s personal data and accept and agree to be
                  bound by this Privacy Policy. If we are informed of any collection of personal
                  data from a minor without the consent of a person with parental responsibility
                  over such minor, we will delete such personal data.
                </p>
                <p>
                  This Privacy Policy applies to personal data of (jointly referred as “you” or
                  “your”):
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>
                      Users: individuals who:
                      <ol className="list-[lower-alpha] list-inside pl-5 space-y-2 pt-2">
                        <li>use, request or receive Services; </li>
                        <li>
                          contact us through our website, Applications or by phone or other means of
                          communications; or
                        </li>
                        <li>subscribe to our updates;</li>
                      </ol>
                    </li>
                    <li>
                      Transporters: individuals who provide or submit applications to us to provide
                      Services through our Applications individually or through partner companies,
                      whether or not subsequently successfully registered as a driver for MOVE.
                    </li>
                  </ol>
                </p>
                <p>
                  Please read this Privacy Policy and understand it before using our website,
                  Services or Applications.
                </p>
              </div>
              <h4>1. Sources of Personal Data</h4>
              <div className="space-y-5 text-justify">
                <p>
                  1.1 Because MOVE is a third party logistics service provider, we receive your
                  Personal Data and Personal Data of other Recipients from Clients or other third
                  party service providers that have engaged our services.
                </p>
                <p>
                  1.2 When you visit our website, access or use our Applications and Services, we
                  are likely to ask you to provide your personal data. If you do not provide the
                  relevant data, we may not be able to provide you with our products or services or
                  respond to any queries you may have. For example, you may not be able to request
                  delivery services through our website or Applications.
                </p>
                <p>
                  1.3 We will collect and process the personal data:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>
                      provided by you directly to us, such as during account creation through our
                      Applications, subscribing to our updates, or sending us correspondence through
                      our website, Applications or by phone;
                    </li>
                    <li>
                      generated during your use of our website, Services and Applications. For
                      example, we may collect your IP address and device information when you visit
                      our website.
                    </li>
                    <li>
                      we obtained from third parties (such as third party agents, other Users, our
                      service providers and business partners). For example, our third party agents
                      may provide us with additional verification and background information of
                      Transporters, other Users may provide us with your name and phone number when
                      booking a vehicle for you.
                    </li>
                  </ol>
                </p>
                <p>
                  1.4 We may also, from time to time, contact you by email, over the phone or in
                  person, to request for additional information that is reasonably required to
                  facilitate the delivery of products to you. In such cases, by providing any
                  Personal Data whether directly or indirectly from Clients or other third party
                  service providers that have engaged our services, you shall be deemed to have
                  consented to the terms of this Policy, including the purposes set out in this
                  Policy for which MOVE collects, uses and discloses your Personal Data.
                </p>
                <p>
                  1.5 We may also collect personal data through software development kits (“SDKs”)
                  used in providing the Services.
                </p>
              </div>
              <h4>2. What Personal Data do we collect from you?</h4>
              <div className="space-y-5 text-justify">
                <p>
                  2.1 When you create a MOVE account, or otherwise provide us with your personal
                  information through the MOVE’s platform, the personal data collected by us about
                  you will include the following data:
                </p>
                <p>
                  from Users:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>Name;</li>
                    <li>email address;</li>
                    <li>phone number;</li>
                    <li>Address;</li>
                    <li>correspondence with us;</li>
                    <li>IP address or other unique device identifiers;</li>
                    <li>payment and banking information;</li>
                    <li>Geolocation;</li>
                    <li>
                      User profile information, including login details and passwords, profile
                      picture,
                    </li>
                    <li>
                      saved routes, language preference, beloved drivers’ details, feedback,
                      ratings, compliments, order details, type of service used and referrer and
                      referee information of a referral program participated by the User;
                    </li>
                    <li>Applications usage or other relevant data; and</li>
                    <li>
                      personal data voluntarily entered by the User in a free text box when using
                      our Services.
                    </li>
                  </ol>
                </p>
                <p>
                  from Transporters:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>Name;</li>
                    <li>phone number;</li>
                    <li>email address;</li>
                    <li>home address;</li>
                    <li>correspondence with us;</li>
                    <li>IP address or other unique device identifiers;</li>
                    <li>payment and banking information;</li>
                    <li>Geolocation;</li>
                    <li>
                      Driver profile information, including login details and passwords, profile
                      picture, vehicle picture, language preference, feedback, ratings, compliments
                      and referrer and referee information of a referral program participated by the
                      Driver;
                    </li>
                    <li>applications usage or other relevant data;</li>
                    <li>driving licence identification number and expiry date;</li>
                    <li>information required to collect and pay any fees;</li>
                    <li>vehicle information and picture;</li>
                    <li>vehicle insurance information;</li>
                    <li>national identification number and expiry date; and</li>
                    <li>date of birth.</li>
                  </ol>
                </p>
                <p>
                  2.2 We only collect personal data that we reasonably need for administration use.
                </p>
              </div>
              <h4>3. How does MOVE use Personal Data?</h4>
              <div className="space-y-5 text-justify">
                <p>
                  3.1 For every Client or third party providers that engages MOVE’s services and, in
                  the process of such engagement, provides MOVE with Personal Data belonging to you
                  and other Recipients, MOVE requires a warranty from the Client that the Client
                  acts in full compliance with the Personal Data Protection Act 2010 of the Laws of
                  Malaysia.
                </p>
                <p>
                  3.2 Specifically, MOVE highlights the following that is required of Client before
                  providing MOVE with any Personal Data:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>
                      Obtain the consent of the Recipient before collecting, using or disclosing
                      his/her Personal Data;
                    </li>
                    <li>
                      Notify the Recipient that their Personal Data will be used by a third party
                      logistics provider, such as MOVE, for the purpose of delivering products from
                      the Client to the Recipient; and
                    </li>
                    <li>
                      Ensure that Personal Data collected is accurate and complete so as to
                      facilitate timely and successful deliveries for the benefit of the Recipient.
                    </li>
                  </ol>
                </p>
                <p>
                  3.3 We may collect, process, compile and collate your personal data in the form
                  of:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>
                      For Users:
                      <ol className="list-[lower-alpha] list-inside pl-5 space-y-2 pt-2">
                        <li>records of profile information;</li>
                        <li>
                          remarks, records and reports of usage of our Services, including records
                          of interaction with customer service;
                        </li>
                        <li>records of payment in respect of our Services;</li>
                        <li>
                          records and reports of usage of our Applications, including bug reports,
                          competitions or contests and login sessions;
                        </li>
                        <li>
                          records of your live chat history and feedback and rating to Transporters;
                        </li>
                      </ol>
                    </li>
                    <li>
                      For Transporters:
                      <ol className="list-[lower-alpha] list-inside pl-5 space-y-2 pt-2">
                        <li>records of profile information;</li>
                        <li>
                          records and reports of usage of our Services, including records of
                          interaction with customer service, Driver operations, field agents and
                          third-party service providers;
                        </li>
                        <li>records of payment in respect of our Services;</li>
                        <li>
                          records and reports of usage of our Applications, including bug reports,
                          competitions or contests and login sessions;
                        </li>
                        <li>reports of live chat history and feedback from Users;</li>
                        <li>records of your deliveries and performance; and</li>
                        <li>
                          records of your vehicles, driving permit, vehicle insurance and vehicle
                          licence.
                        </li>
                      </ol>
                    </li>
                  </ol>
                </p>
                <p>
                  3.4 We may process your personal data for the following purposes.
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>
                      Users:
                      <ol className="list-[lower-alpha] list-inside pl-5 space-y-2 pt-2">
                        <li>to provide and maintain our Services such as to:</li>
                        <ol className="list-[lower-roman] list-inside pl-5 space-y-2 pt-2">
                          <li>create, update and maintain your account registered with us;</li>
                          <li>enable transportation and deliveries;</li>
                          <li>track deliveries; and</li>
                          <li>
                            offer, process or facilitate payment for deliveries or our Services.
                          </li>
                        </ol>
                        <li>to monitor the use of our website, Services or Applications;</li>
                        <li>
                          to help maintain the safety, security and integrity of our Services and
                          prevent crime and fraud;
                        </li>
                        <li>
                          to personalise your experience on our Applications: identifying your
                          preferences and behaviour help us to better understand your individual
                          needs and interests and provide you with more tailored Services. We may
                          require your consent for some of this marketing activity. In such cases
                          where consent is required, we will only conduct the marketing activity if
                          we have obtained your consent. You may choose to unsubscribe at any time
                          if you do not wish to receive such information;
                        </li>
                        <li>
                          to improve our website, Services and Applications or develop new ones: we
                          may use your personal data to develop new features and functionality, to
                          improve our software and interface design, we may use the error reports to
                          improve security features;
                        </li>
                        <li>
                          for customer service: your personal data helps us to more effectively
                          respond to your customer service requests, receive feedback and support
                          needs;
                        </li>
                        <li>
                          for research and development: your personal data will help us test,
                          research, analyse, assist with product development and machine learning to
                          improve your experience;
                        </li>
                        <li>
                          to compile aggregate statistics about you and to analyse your Services and
                          Applications usage;
                        </li>
                        <li>
                          for non-marketing communications related to our Services such as
                          notifications of changes to our Applications or our Services;
                        </li>
                        <li>
                          to administer our business: we may use your personal data for the
                          management and administration of our business (including administering and
                          maintaining databases storing personal data);
                        </li>
                        <li>
                          for legal proceedings or as required by regulators, government entities
                          and official enquiries, or to comply with our legal obligations; and
                        </li>
                        <li>
                          for direct marketing, subject to having obtained your consent in
                          accordance with applicable laws.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Transporters:
                      <ol className="list-[lower-alpha] list-inside pl-5 space-y-2 pt-2">
                        <li>to provide and maintain our Services such as to:</li>
                        <ol className="list-[lower-roman] list-inside pl-5 space-y-2 pt-2">
                          <li>create, update and maintain your account registered with us;</li>
                          <li>enable and notify transportation, orders and deliveries;</li>
                          <li>track deliveries; and</li>
                          <li>
                            offer, process or facilitate payment for deliveries or our Services.
                          </li>
                        </ol>
                        <li>to monitor the use of our Services, Applications and website;</li>
                        <li>
                          to help maintain the safety, security and integrity of our Services and
                          prevent crime and fraud, such as to screen Transporters;
                        </li>
                        <li>
                          to personalise your experience on our Applications: identifying your
                          preferences and behaviour help us to better understand your individual
                          needs and interests and provide you with more tailored Services. We may
                          require your consent for some of this marketing activity. In such cases
                          where consent is required, we will only conduct the marketing activity if
                          we have obtained your consent. You may choose to unsubscribe at any time
                          if you do not wish to receive such information;
                        </li>
                        <li>
                          to improve our website, Services and Applications or develop new ones: we
                          may use your personal data to develop new features and functionality, to
                          improve our software and interface design, we may use the error reports to
                          improve security features;
                        </li>
                        <li>
                          for customer service: your personal data helps us to more effectively
                          respond to your customer service requests, receive feedback and support
                          needs;
                        </li>
                        <li>
                          for research and development: your personal data will help us test,
                          research, analyse, assist with product development and machine learning to
                          improve your experience;
                        </li>
                        <li>
                          to compile aggregate statistics about you and to analyse your Services and
                          Applications usage and deliveries, including performance metrics of
                          services provided by the Transporter;
                        </li>
                        <li>
                          for non-marketing communications related to our Services such as
                          notifications of changes to our Applications or our Services;
                        </li>
                        <li>
                          to administer our business: we may use your personal data for the
                          management and administration of our business (including administering and
                          maintaining databases storing personal data);
                        </li>
                        <li>
                          for legal proceedings or as required by regulators, government entities
                          and official enquiries, or to comply with our legal obligations;
                        </li>
                        <li>
                          for direct marketing, subject to having obtained your consent in
                          accordance with applicable laws.
                        </li>
                        <li>
                          for providing benefits to the Transporters, including the purchase of
                          insurance.
                        </li>
                      </ol>
                    </li>
                  </ol>
                </p>
                <p>
                  3.5 If we want to use your personal data for other purposes not covered by this
                  Privacy Policy, we will notify you and obtain your prior consent where applicable,
                  and ensure that the use of your personal data complies with the applicable laws.
                </p>
                <p>
                  3.6 We are allowed to use your personal data in these ways because of one or more
                  of the following apply:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>we have obtained your consent;</li>
                    <li>
                      we need to do so in order to perform our contractual obligations with you;
                    </li>
                    <li>
                      we have legal duties and regulatory obligations that we have to discharge;
                    </li>
                    <li>
                      the use of your personal data as described is necessary for our legitimate
                      interests;
                    </li>
                    <li>
                      we need to do so in order to response to public health incidents or to protect
                      the vital interests of nature persons; or
                    </li>
                    <li>
                      we have other legal bases allowed by applicable laws to process your personal
                      data.
                    </li>
                  </ol>
                </p>
                <p>
                  3.7 Not all data protection laws are the same so not all of the legal bases listed
                  in paragraph 3.6 apply in all jurisdictions (e.g. legitimate interests are not a
                  legal basis allowed in some jurisdictions). We will process your personal data in
                  accordance with the legal basis permitted by applicable laws in your jurisdiction.
                </p>
                <p>
                  3.8 Your personal data collected by us will not be sold, exchanged, shared,
                  transferred or given to a third party for their own direct marketing purposes
                  unless we have your prior consent or we are other legal bases allowed by
                  applicable laws.
                </p>
              </div>
              <h4>4. Personal Data sharing and disclosure</h4>
              <div className="space-y-5 text-justify">
                <p>
                  4.1 The personal information we collect from you will be used, or shared with
                  third parties (including related companies, third party service providers, and
                  third party sellers), including purposes of serving you, ensuring timely and
                  successful deliveries to you, and improving our service quality to you and for
                  some or all of the following purposes (where applicable).
                </p>
                <p>
                  4.2 Our Services require that we share your personal data with other users. This
                  includes:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>
                      sharing Users’ full name, phone number, personal data entered by a User, and
                      pick up or drop off locations with Transporters after a delivery has been
                      initiated for the purposes of completing a delivery;
                    </li>
                    <li>
                      sharing the Transporter’s name, phone number, driver profile information,
                      vehicle information, vehicle picture and geolocation with Users after a
                      delivery has been initiated for the purposes of completing a delivery;{' '}
                    </li>
                    <li>
                      You should take care when disclosing your personal data to Transporters, or to
                      Users. You understand and acknowledge that we cannot control the actions of
                      other users with whom you may choose to share the personal data with. We do
                      not monitor the use of such features in the normal course of business although
                      we reserve the right to do so at our discretion.
                    </li>
                    <li>
                      Therefore, you understand and acknowledge that we cannot and do not guarantee
                      that the personal data you share with other users will not be reviewed by
                      unauthorised persons. You also acknowledge that your personal data may still
                      be accessed by the relevant users with whom you shared the personal data with
                      after the delivery is completed. For example, the relevant user may view the
                      transaction records which contain your personal data.
                    </li>
                    <li>
                      We may also share your personal data to provide our website, Services,
                      Applications or for legal reasons with:
                      <ol className="list-[lower-alpha] list-inside pl-5 space-y-2 pt-2">
                        <li>our employees, officers or independent consultants;</li>
                        <li>our auditors and external legal and financial advisors;</li>
                        <li>
                          our suppliers, business partners, data processors and sub-contractors
                          including:
                          <ol className="list-[lower-roman] list-inside pl-5 space-y-2 pt-2">
                            <li>IT service and software suppliers;</li>
                            <li>payment processors and facilitators;</li>
                            <li>cloud platform service providers;</li>
                            <li>cloud storage providers;</li>
                            <li>data analytics providers;</li>
                            <li>research partners;</li>
                            <li>
                              marketing and advertising agencies who create our advertisements and
                              promotions;
                            </li>
                            <li>background check and identity verification providers;</li>
                            <li>
                              vendors that assist us to enhance the safety and security of our
                              website and Applications; and
                            </li>
                            <li>customer service providers;</li>
                          </ol>
                        </li>
                        <li>our insurers and bankers, and Transporters’ insurers;</li>
                        <li>
                          any regulator or government body to whom we are under an obligation or
                          otherwise required to make disclosure under the requirements of any
                          applicable laws;
                        </li>
                        <li>
                          our affiliates: we share personal data with our subsidiaries and parent
                          companies and other affiliates to help us provide our Services or conduct
                          data processing on our behalf;
                        </li>
                        <li>
                          any applicable persons if we believe it is required by applicable laws,
                          legal process, governmental request or where the disclosure is appropriate
                          due to safety concerns. This includes exchanging your personal data with
                          other companies or organisations for the purposes of crime / fraud
                          protection and prevention; or
                        </li>
                        <li>
                          another company with connection in or during negotiations of any merger,
                          sale of company assets, consolidation or restructuring, financing or
                          acquisition of all or a portion of our business by or into that other
                          company.
                        </li>
                      </ol>
                    </li>
                    <li>
                      We will ensure third parties are under confidentiality obligations before we
                      share your personal data with the third parties set out in paragraph 4.2 of
                      this Privacy Policy.
                    </li>
                    <li>
                      We may share your personal data with anyone other than as described in
                      paragraph 4.2 of this Privacy Policy. Under such circumstances, we will notify
                      you and will receive your consent beforehand if required by applicable laws.
                    </li>
                    <li>
                      We do not sell your personal data to any third parties and guarantee the
                      legitimate and fair use of personal data only to the extent permitted by law.
                    </li>
                  </ol>
                </p>
              </div>
              <h4>5. Security of Personal Data</h4>
              <div className="space-y-5 text-justify">
                <p>
                  5.1 Once we receive your personal data, we will use all reasonably practicable
                  steps and security measures as required under the applicable laws, to ensure that
                  your personal data is stored securely and protected by us and our data processors
                  against unauthorised or accidental access, processing, erasure, loss or use.
                </p>
                <p>
                  5.2 Your personal data will be kept confidential and secure except for the
                  purposes and uses as set out in this Privacy Policy and will only be disclosed on
                  a “need-to-know” basis.
                </p>
                <p>
                  5.3 If we outsource and entrust your personal data with data processors, we will
                  use contractual and other means to monitor the data processors’ compliance with
                  this Privacy Policy.
                </p>
                <p>
                  5.4 We have adopted organisational, physical and technical security measures that
                  are in line with the industry standards to protect the personal data you provide.{' '}
                </p>
                <p>
                  5.5 You are responsible for keeping your Applications password confidential. You
                  must not disclose or otherwise reveal your Applications password to any third
                  parties. Please let us know immediately if you believe your password or record has
                  been compromised.
                </p>
                <p>
                  5.6 The transmission of information through the internet is not completely secure.
                  Although we use security measures to secure your personal data, we cannot
                  guarantee the security of your personal data transmitted to the Applications and
                  any transmission is at your own risk.
                </p>
              </div>
              <h4>6. Retention of Personal Data</h4>
              <div className="space-y-5 text-justify">
                <p>
                  6.1 Personal data collected from you will not be kept longer than necessary for
                  the carrying out of the purposes stated in paragraph 3 of this Privacy Policy,
                  unless otherwise required or permitted by applicable laws.
                </p>
                <p>
                  6.2 If your account registered with our Applications has not been accessed over a
                  period of three years or we have closed your account upon your request (“End
                  Date”), your personal data will be retained by us for as long as is necessary for
                  the purposes stated in paragraph 3 of this Privacy Policy, or for as long as is
                  permitted by applicable laws. We may retain your personal data for a longer period
                  if it is necessary for us to do so to comply with our contractual or legal
                  obligations, or you have consented to our continued retention of it.
                </p>
                <p>
                  6.3 At the end of the retention period, we will ensure that your personal data,
                  all app-related data and account-related information will be deleted. For any
                  physical documents containing your personal data, the documents will be shredded
                  or otherwise destroyed by means that ensure the confidential and secure
                  destruction of the documents.
                </p>
                <p>
                  6.4 We will ensure that our data processors only retain your personal data only
                  for as long as is necessary for the fulfilment of the purposes stated in paragraph
                  3 of this Privacy Policy. Our data processors will delete personal data held if
                  personal data is no longer required for the purposes stated in paragraph 3 of this
                  Privacy Policy unless any deletion is prohibited under applicable laws.
                </p>
              </div>
              <h4>7. Your rights</h4>
              <div className="space-y-5 text-justify">
                <p>
                  7.1 We respect your legal rights to your personal data. We list below your legal
                  rights and the measures we take to protect these rights. Not all data protection
                  laws are the same so not all of these rights apply in all jurisdictions.
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>
                      the right to obtain information regarding the processing of your personal data
                      and access to the personal data which we hold about you;
                    </li>
                    <li>
                      the right to request that we rectify your personal data if it is inaccurate or
                      incomplete;
                    </li>
                    <li>
                      the right to request that we erase, block or anonymise your personal data in
                      certain circumstances. Please note that there may be circumstances where you
                      ask us to erase, block or anonymise your personal data, but we are legally
                      entitled to retain it;
                    </li>
                    <li>
                      in some circumstances, the right to receive some personal data in a
                      structured, commonly used and machine-readable format and/or request that we
                      transmit this data to a third party where this is technically feasible. Please
                      note that this right only applies to personal data which you have provided to
                      us;
                    </li>
                    <li>
                      the right to withdraw your consent to our processing of your personal data.
                      Please note, however, that we may still be entitled to process your personal
                      data if we have another legitimate reason (other than consent) for doing so.
                      For example, we may need to retain your personal data to comply with a legal
                      obligation;
                    </li>
                    <li>
                      the right to obtain information about the possibility of refusing consent and
                      the respective consequences. When the consent is used as legal basis for the
                      processing of personal data, you are entitled to be informed about the
                      possibility of refusing consent and the consequence of such refusal;
                    </li>
                    <li>
                      the right to object to, and the right to request that we restrict our
                      processing of your personal data in certain circumstances. There may be
                      circumstances where you object to, or ask us to restrict our processing of
                      your personal data but we are legally entitled to continue processing your
                      personal data and/or to refuse that request;
                    </li>
                    <li>
                      the right to request us for the history your personal data that we have
                      collected;
                    </li>
                    <li>
                      the right not to be subject to a decision based solely on automated
                      processing; and
                    </li>
                    <li>
                      the right to lodge a complaint with the competent authority if you think that
                      any of your rights have been infringed by us.
                    </li>
                  </ol>
                </p>
                <p>
                  7.2 We will take appropriate technical measures to enable you to control how we
                  use your personal data. In addition to exercising some of your rights through your
                  Applications account, you can exercise all your rights by contacting us using the
                  details set out in the “Contact Us” section below.
                </p>
              </div>
              <h4>8. Third party links</h4>
              <div className="space-y-5 text-justify">
                <p>
                  8.1 Occasionally, at our discretion, we may include or offer links to third-party
                  products or services on our website or Applications.
                </p>
                <p>
                  8.2 These third party websites have their own separate and independent privacy
                  policies and user terms which you must review before using their services.
                </p>
                <p>
                  8.3 We take no responsibility or liability for the content and activities of these
                  third-party linked websites or their products and services.
                </p>
                <p>
                  8.4 We seek to protect the integrity of our website and Applications and welcome
                  any feedback on these third party links.
                </p>
              </div>
              <h4>9. Changes to this Policy</h4>
              <div className="space-y-5 text-justify">
                <p>
                  9.1 MOVE reserves the right to amend this Policy from time to time, in accordance
                  with the prevailing law. The amended Policy shall at all times be available on our
                  website.
                </p>
                <p>
                  9.2 When we update our Privacy Policy, we will take appropriate measures to inform
                  you, consistent with the significance of the changes we make. We will obtain your
                  consent to any material Privacy Policy changes if and where this is required by
                  applicable laws.{' '}
                </p>
                <p>
                  9.3 You should review this Privacy Policy periodically. By continuing to use our
                  website, our Applications or Services you will be deemed to have accepted the
                  changes or updates to this Privacy Policy. If you do not consent to such changes
                  or updates made to the Privacy Policy, we will not be able to provide you access
                  to our Applications or provide our Services to you.
                </p>
              </div>
              <h4>10. Contact Us</h4>
              <div className="space-y-5 text-justify">
                <p>
                  10.1 All comments, queries, complaints, data access requests or data correction
                  requests relating to our use of your personal data are welcome and should be
                  addressed to: email
                </p>
              </div>
              <h4>11. Governing Law</h4>
              <div className="space-y-5 text-justify">
                <p>
                  11. 1 MOVE’s Personal Data Protection Policy is governed by the laws of Malaysia
                  and any dispute relating to this Policy shall be submitted to the exclusive
                  jurisdiction of the courts of Malaysia.
                </p>
              </div>
              <h4>12. MOVE’s rights</h4>
              <div className="space-y-5 text-justify">
                <p>
                  12.1 You acknowledge and agree that MOVE has the right to disclose your personal
                  information to any legal, regulatory, governmental, tax, law enforcement or other
                  authorities or the relevant right owners, if MOVE has reasonable grounds to
                  believe that disclosure of your personal information is necessary for the purpose
                  of meeting any obligations, requirements or arrangements, whether voluntary or
                  mandatory, as a result of cooperating with an order, an investigation and/or a
                  request of any nature by such parties. to the extent permissible by applicable
                  law, you agree not to take any action and/or waive your rights to take any action
                  against MOVE for the disclosure of your personal information in these
                  circumstances.
                </p>
              </div>
            </div>
          </div>
        </div>
        <SignUpButtonGroup />
      </div>
    </StaticPageLayout>
  );
};

export default PrivacyPage;
